module.exports = __webpack_public_path__ + "static/media/im.102e60fe.svg";